import { render } from "./ViewRatioRow.vue?vue&type=template&id=7d1ed614&scoped=true"
import script from "./ViewRatioRow.vue?vue&type=script&lang=js"
export * from "./ViewRatioRow.vue?vue&type=script&lang=js"

import "./ViewRatioRow.vue?vue&type=style&index=0&id=7d1ed614&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d1ed614"

export default script